export default __webpack_public_path__ + "static/TheSwedishchefwhoreinventedfire-09a5f717e5f5135b4199d9b224b577d1.jpg";